export default __webpack_public_path__ + "images/check-icon.a760806.svg";